export enum AccountStatus {
  INACTIVE = "Inactive",
  NURTURE = "Nurture",
  WORKING = "Working",
  CALL_SCHEDULED = "CallScheduled",
  OPEN_OPPORTUNITY = "OpenOpportunity",
  CUSTOMER = "Customer",
}
